import { createContext, useReducer } from 'react';
import MovementEntity from '../../models/MovementEntity';

export const MovementContext = createContext();

const MovementProvider = ({ children, movement }) => {
    const reducer = (state, action) => {
        switch (action.type) {
            case 'EDIT':
                return {
                    ...state,
                    ...action.payload,
                }
            case 'REPLACE': {
                return action.movement
            }
            case 'CLEAR': {
                return MovementEntity
            }
            default:
                return state
        }
    }

    return (
        <MovementContext.Provider value={useReducer(reducer, { ...MovementEntity, ...movement })}>
            {children}
        </MovementContext.Provider>
    )
}

export default MovementProvider;